<script setup lang="ts">
import CheckBox from '../../Form/CheckBox.vue';
import { useClassStore } from '../../../stores';
import { computed } from 'vue';

const studentIds = defineModel<number[]>()

const classStore = useClassStore()

const selectedGroupIds = computed<number[]>({
    get() {
        const groupIds: number[] = []
        classStore.studentGroups.forEach(studentGroup => {
            if (!studentGroup.students?.length) return;
            if (studentGroup.students?.some(student => !studentIds.value?.includes(student.id))) return;
            groupIds.push(studentGroup.id)
        })
        return groupIds
    },
    set(groupIds: number[]) {
        const removedGroupIds = selectedGroupIds.value.filter(groupId => !groupIds.includes(groupId))
        const studentIdsUpdate = [...(studentIds.value || [])]
        classStore.studentGroups.forEach(studentGroup => {
            if (groupIds.includes(studentGroup.id)) {
                studentGroup.students?.forEach(student => {
                    if (studentIdsUpdate?.includes(student.id)) return;
                    studentIdsUpdate.push(student.id)
                })
            }

            if (removedGroupIds.includes(studentGroup.id)) {
                studentGroup.students?.forEach(student => {
                    const studentIdIndex = studentIdsUpdate.findIndex(studentId => studentId === student.id)
                    if (studentIdIndex < 0) return;
                    studentIdsUpdate.splice(studentIdIndex, 1)
                })
            }
        })
        studentIds.value = studentIdsUpdate
    }
})
</script>

<template>
    <label class="flex items-center gap-3 py-2 px-3 transition-all hover:bg-neutral-100 cursor-pointer"
        v-for="group in classStore.studentGroups.filter(group => group.students?.length)">
        <span class="text-blue-600 font-bold">{{ group.name }}</span>
        <CheckBox v-model="selectedGroupIds" :value="group.id" class="ml-auto" />
    </label>
</template>